export default "__VITE_ASSET__BoHOGuOT__"